module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"level":"Nivå {level}.{sublevel}","loadingIndicator":"Laster...","quiz":"Quiz","memorize":"Memorer"},"en":{"level":"Level {level}.{sublevel}","loadingIndicator":"Loading...","quiz":"Quiz","memorize":"Memorize"}}')
  delete Component.options._Ctor
}
